import { Attendance } from "@/@types/sintegrada/Attendance";
import { sintegradaApi } from "@/services/api";

export type EvasionsInRiskClassificationParams = {
	uf: string;
	ibgeCode: string;
	startDate: string;
	endDate: string;
	cnes?: string;
	youngerAge?: number;
	olderAge?: number;
};

export async function getEvasionsInRiskClassification({
	uf,
	ibgeCode,
	...params
}: EvasionsInRiskClassificationParams) {
	const response = await sintegradaApi.get<Attendance[]>(
		`/uf/${uf}/city/${ibgeCode}/attendance/evasions-in-risk-classification`,
		params
	);
	return response.data || [];
}
